import { Text, Show } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { CbAlertBanner, CbButton, CbLink } from 'ui/components';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
export const LowBalanceBanner = () => {
  const router = useRouter();
  const handleBuyTokens = async () => {
    await router.replace({
      pathname: '/manage/transactions',
      query: {
        drawer: 'BuyTokens'
      }
    });
  };
  return <CbAlertBanner bannerId="low-tokens" dismissable data-sentry-element="CbAlertBanner" data-sentry-component="LowBalanceBanner" data-sentry-source-file="LowBalanceBanner.tsx">
      <Text data-sentry-element="Text" data-sentry-source-file="LowBalanceBanner.tsx">
        {'Your token balance is low. This will impact your running games. '}
        <Show below="sm" data-sentry-element="Show" data-sentry-source-file="LowBalanceBanner.tsx">
          <CbLink color="white" textDecoration="underline" href="/manage/transactions?drawer=BuyTokens" whiteSpace="nowrap" data-sentry-element="CbLink" data-sentry-source-file="LowBalanceBanner.tsx">
            {'Buy Tokens'}
          </CbLink>
        </Show>
      </Text>
      <Show above="sm" data-sentry-element="Show" data-sentry-source-file="LowBalanceBanner.tsx">
        <CbButton variant="ghost-on-dark" onClick={handleBuyTokens} data-sentry-element="CbButton" data-sentry-source-file="LowBalanceBanner.tsx">
          <ICON_BY_NAME.coins marginRight={2} data-sentry-element="unknown" data-sentry-source-file="LowBalanceBanner.tsx" />
          {'Buy Tokens'}
        </CbButton>
      </Show>
    </CbAlertBanner>;
};